export enum CalendarConnectionStatus {
  ACTIVE = 'active',
  DISCONNECTED = 'disconnected',
  PENDING_OAUTH = 'pending_oauth',
}

export interface CalendarMetadataDto {
  id: string;
  name: string;
  enabled: boolean;
  readonly?: boolean;
  calendarProvider?: string;
  calendarPrimary?: boolean;
  providerName?: string;
}

export type CalendarConnectionStatusDto = {
  userProfileId: number;
  status: CalendarConnectionStatus;
  provider?: 'cronofy';
  needsUpgrade?: boolean;
  defaultCalendarId?: string;
  calendars?: CalendarMetadataDto[];
};

export interface CalendarConnectionStatusBatchRequest {
  userProfileIds: string[];
}

export type CalendarConnectionStatusResponse = CalendarConnectionStatusDto[];

export interface InitiateOAuthResponse {
  authUrl: string;
  state: string;
  redirectUrl?: string;
}

export interface UpdateDefaultCalendarDto {
  calendarId: string;
}

export interface UpdateCalendarEnabledDto {
  calendarId: string;
  enabled: boolean;
}
